<template>
  <div class="stats-cards">
    <div class="stat-card">
      <div class="stat-value">{{ statistics.totalProducts.toLocaleString() }}</div>
      <div class="stat-label">Total Products</div>
    </div>
    <div class="stat-card">
      <div class="stat-value">{{ statistics.costsSet.toLocaleString() }}</div>
      <div class="stat-label">Costs Set</div>
      <div class="stat-percentage">({{ statistics.percentageSet }}%)</div>
    </div>
    <div class="stat-card">
      <div class="stat-value">{{ statistics.missingCosts.toLocaleString() }}</div>
      <div class="stat-label">Missing Costs</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatisticsCards',
  props: {
    statistics: {
      type: Object,
      required: true,
      default: function () {
        return {
          totalProducts: 0,
          costsSet: 0,
          missingCosts: 0,
          percentageSet: 0
        }
      }
    }
  }
}
</script>

<style scoped>
@import './styles/StatisticsCards.css';
</style>




// WEBPACK FOOTER //
// StatisticsCards.vue?656c9c58